import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { RowActionPayload, RowActionResult, UUID } from "@/lib/types";

export function useRowAction(rowId: UUID | undefined, boardId: UUID | undefined) {
  const qc = useQueryClient();
  return useMutation<RowActionResult, Error, RowActionPayload>({
    mutationFn: (payload) => api.performRowAction(rowId as UUID, payload),
    onSuccess: () => {
      if (rowId) {
        void qc.invalidateQueries({ queryKey: queryKeys.rowComments(rowId) });
      }
      if (boardId) {
        void qc.invalidateQueries({ queryKey: queryKeys.board(boardId) });
      }
      void qc.invalidateQueries({ queryKey: queryKeys.notifications });
      void qc.invalidateQueries({ queryKey: queryKeys.notificationsUnread });
      void qc.invalidateQueries({ queryKey: queryKeys.mySubmissions });
      void qc.invalidateQueries({ queryKey: queryKeys.assignedCount });
    },
  });
}
